/**
 * Retorna a forma abreviada.
 *
 * true = Útil
 *
 * false = Não Útil
 */
const abreviar = {
	Bloqueado: true,
	Desbloqueado: false,
}

/**
 * Retorna a palavra completa juntamente com a classe que deve ser aplicada caso use o componente Tag.
 *
 * true = Útil
 *
 * false = Não Útil
 */
const desabreviar = {
	true: 'Bloqueado',
	false: 'Desbloqueado',
}

export { abreviar, desabreviar }
